import classNames from "classnames";
import React, { FC } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { AutomationSummaryPart, needsSpaceBefore } from "./automation.summary";

type Props = {
  id: string;
  parts: AutomationSummaryPart[];
};

/**
 * Hover card for the yellow ⚡ next to a subtask (Roadmap 1801): small
 * "AUTOMATION RULE" heading, then the rule with the subtask name in purple
 * and the picked values in bold.
 */
export const AutomationRuleTooltip: FC<Props> = ({ id, parts }) => (
  <ReactTooltip
    id={id}
    place={"top"}
    positionStrategy={"fixed"}
    opacity={1}
    noArrow
    className={
      "z-[10000] !max-w-[320px] !rounded-xl !border !border-[#E4DEFF] !bg-[#F6F3FF] !px-4 !py-3 !text-left !font-Manrope !shadow-[0_10px_28px_rgba(31,36,51,0.14)]"
    }>
    <div
      className={
        "mb-1.5 text-[10px] font-bold uppercase tracking-[0.08em] text-[#8B90A3]"
      }>
      Automation rule
    </div>
    <p className={"m-0 text-xs font-normal leading-[18px] text-[#1F2433]"}>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {needsSpaceBefore(part, index) ? " " : ""}
          <span
            className={classNames(
              part.kind === "name" && "font-bold text-[#6B4EFF]",
              part.kind === "value" && "font-bold",
            )}>
            {part.text}
          </span>
        </React.Fragment>
      ))}
    </p>
  </ReactTooltip>
);
